<h2 mat-dialog-title>
  {{ 'RECORDING_VISIBILITY.DIALOG.TITLE_V2' | translate }}
</h2>
<mat-dialog-content>
  <div class="dialog-content">
    <span>{{ 'RECORDING_VISIBILITY.DIALOG.DESCRIPTION_V2' | translate }}</span>
    <ul class="unordered-list">
      <li>
        <b>{{ 'RECORDING_VISIBILITY.DIALOG.OPTION_1_TITLE' | translate }}</b>
        &nbsp;{{ 'RECORDING_VISIBILITY.DIALOG.OPTION_1_DESCRIPTION' | translate }}
      </li>
      <br>
      <li>
        <b>{{ 'RECORDING_VISIBILITY.DIALOG.OPTION_2_TITLE' | translate }}</b>
        &nbsp;{{ 'RECORDING_VISIBILITY.DIALOG.OPTION_2_DESCRIPTION' | translate }}
      </li>
    </ul>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button tabIndex="-1" [routerLink]="'/events-and-meetings/meeting-settings'"
          fragment="recording-settings" mat-dialog-close>
    {{ 'RECORDING_VISIBILITY.DIALOG.REVIEW_SETTINGS' | translate }}
  </button>
  <button mat-flat-button mat-dialog-close tabIndex="-1" color="primary">
    {{ 'COMMON.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
